module.exports = {
  btn: {
    btn1: '確定',
    btn2: '取消',
    btn3: '支取',
    btn4: '完成',
    btn5: '示例',
    btn6: '試算',
    btn7: '返回',
    btn8: '立即支取',
    btn9: '我知道了',
    btn10: '全部支取並解約'
  },
  label: {
    label0: '智能存款 火爆發售',
    label1: '活期的便利 定期的收益',
    label2: '存入',
    label3: '不在服務時間。',
    label4: '交易時間為每日0:00-21:00。',
    label5: '零錢輕鬆籌',
    label6: '半年/一年娛樂計劃',
    label7: '為親愛的Ta準備一份聖誕/生日驚喜',
    label8: '存工資輕鬆無憂',
    label9: '請先登錄。',
    label10: '零錢儲一儲 都是一大筆',
    label11: '餘額自動轉入 讓您輕鬆享收益',
    label12: '定期派息',
    label13: '當日計息',
    label14: '省心省力',
    label15: '新增計劃',
    label16: '年度娛樂 盡早籌劃',
    label17: '準備一趟甜美的旅行',
    label18: '',
    label19: '新款的包包真係靚',
    label20: '',
    label21: '為學習愛好積攢資金',
    label22: '',
    label23: '每月自動攢 財富一定讚',
    label24: '工資到賬',
    label25: '自動存入',
    label26: '收益buff',
    label27: '主動加薪',
    label28: '聖誕/生日在即 禮物要急',
    label29: '離聖誕只有100天 來不及準備禮物資金啊',
    label30: '不要急 智能存款會幫您',
    label31: '月供存款',
    label32: '活期存款',
    label33: '月月高存款',
    label34: '天天利存款',
    label35: '定期存款',
    label36: '月月儲錢月月多',
    label37: '零錢錢包儲不停',
    label38: '按月靠檔利率高',
    label39: '按天靠檔利率高',
    label40: '定期儲錢最放心',
    label41: '我的',
    label42: '2萬以下',
    label43: '2萬（含2萬）~100萬',
    label44: '100萬以上（含100萬）',
    label45: '0-10萬',
    label46: '10-20萬',
    label47: '20-50萬',
    label48: '50萬以上（含50萬）',
    label49: '20-100萬',
    label50: '10-50萬',
    label51: '存期',
    label52: '存入',
    label53: '交易記錄',
    label54: '總持倉',
    label55: '累計收益',
    label56: '共',
    label57: '種存款',
    label58: '購買金額',
    label59: '預計到期可得金額',
    label60: '存期',
    label61: ' 已存入',
    label62: '天',
    label63: '到期',
    label64: '預計到期金額',
    label65: '期限',
    label66: '利率',
    label67: '購買幣種',
    label68: '購買賬戶',
    label69: '收益賬戶',
    label70: '存款期限',
    label71: '存款利率',
    label72: '個月',
    label73: '交易記錄',
    label74: '溫馨提示：月月高存款產品提前支取只支持提前全部支取',
    label75: '温馨提示：活期产品提前支取可部分或全部支取。',
    label76: '若需終止此產品需進行解除簽約。',
    label77: '提前支取',
    label78: '解除簽約',
    label79: '溫馨提示：定期存款產品提前支取只支持提前全部支取',
    label80: '溫馨提示：天天利存款產品提前支取只支持提前全部支取',
    label81: '溫馨提示：月供存款產品提前支取只支持提前全部支取',
    label82: '篩選',
    label83: '重置',
    label84: '交易對象',
    label85: '全部對象',
    label86: '活期',
    label87: '定期',
    label88: '天天利',
    label89: '月供存款',
    label90: '月月高',
    label91: '交易類型',
    label92: '購買',
    label93: '全部類型',
    label94: '贖回',
    label95: '結息',
    label96: '供款',
    label97: '利息轉存',
    label98: '存入幣種',
    label99: '存入期限',
    label100: '購買賬戶',
    label101: '存入金額',
    label102: '起購金額{0}起',
    label103: '請選擇購買賬戶',
    label104: '全部存入',
    label105: '賬戶當前可用餘額',
    label106: '我已閱讀',
    label107: '留存金額',
    label108: '簽約賬戶',
    label109: '派息頻率',
    label110: '供款金額',
    label111: '供款賬戶',
    label112: '信息確認',
    label113: '交易失敗請檢查',
    label114: '存入成功',
    label115: '申請已提交',
    label116: '當日計息',
    label117: '到期',
    label118: '支取失敗請檢查',
    label119: '交易成功',
    label120: '本金',
    label121: '利息',
    label122: '計息規則',
    label123: '',
    label124: '{0}元起存，存期內按存款月數和存款金额靠檔計息，一次性存入本金，支持全部提前支取。',
    label125: '按照存入當日我行APP產品頁面公佈的產品利率靠檔計付利息',
    label126: '可全部提前支取，當存夠一檔月數計付對應的利息，未存夠下一檔月數無利息。',
    label127: '收益計算器',
    label128: '請選擇幣種',
    label129: '請選擇存期',
    label130: '拖動滑條選擇您要存入的金額',
    label131: '預計到期可獲取收益',
    label132: '開啟您的存款計劃',
    label133: '買入',
    label134: '到期日',
    label135: '如客戶存入MOP10萬，3+2+1個月，到期支取，存期滿6個月，利息為MOP10萬*（{0}/365*3個月實際天數+{1}/365*2個月實際天數+{2}/365*1個月實際天數）',
    label136: '活期產品{0}元起存，設定簽約活期賬戶的留存金額，當日終賬戶餘額大於留存金額時，大於部分存入日日賺；當日終賬戶餘額小於留存金額時，小於部分從日日賺返回活期賬戶。支持全部或部分提取本金及利息。',
    label137: '按照存入當日我行APP產品頁面公佈的產品利率靠檔計付利息。',
    label138: '如客戶購買並簽約了1萬MOP幣種日均存款産品。',
    label139: '日均餘額0-10萬，年利率為{0}%；日均餘額10-20萬，年利率為{1}%;',
    label140: '日均餘額20-50萬，年利率為{0}%；日均餘額50萬及以上，年利率為{1}%。',
    label141: '如客戶購買並簽約了1萬MOP幣種定期產品，存期為3個月，最高利率為{0}%',
    label142: '定期产品',
    label143: '{0}元起存，存期內按存款月數和存款金额靠檔計息，一次性存入本金，支持全部提前支取。',
    label144: '按照存入當日我行APP產品頁面公布的產品利率靠檔計付利息；',
    label145: '可全部提前支取，提前支取部分按支取當日我行提前支取利率計息。',
    label146: '{0}元起存，存期內按存款天數靠檔計息，按固定天數派息，一次性存入本金，支持全部提前支取本金和利息。',
    label147: '按照存入當日我行APP產品頁面公佈的產品利率靠檔計付利息；',
    label148: '可全部提前支取，支取金額按存款天數對應的產品利率靠檔計息。',
    label149: '派息規則',
    label150: '存期50天，每15天派息一次；',
    label151: '存期100天，每30天派息一次；',
    label152: '存期160天，每50天派息一次。',
    label153: '160天天利存款之利息將分為3個階段計算，1）第1階段為開立存款日起計算100日；第2階段為開立存款日起計第101日至150日；第3階段為開立存款日起第151日至存款到期日。2）存款利息每50日派息一次。',
    label154: '{0}元起存，每月供款金額不少於{1}元，存款時約定存期，每月1號扣款，到期自動返還本金和利息，支持全部提前支取。',
    label155: '按照存入當日我行APP產品頁面公佈的產品利率計付利息；',
    label156: '可全部提前支取，提前支取無利息。',
    label157: '1.計息每年按360天，每月按30天計算',
    label158: '2.按存款金額實際存期計息，開戶金額*日利率*實際存入日數+第1期供款金額*日利率*實際存入日數+第2期供款金額*日利率*實際存入日數+…...+第12期供款金額*日利率*實際存入日數',
    label159: '最高',
    label160: '澳門幣',
    label161: '人民幣',
    label162: '港幣',
    label163: '美元',
    label164: '加元',
    label165: '英鎊',
    label166: '澳元',
    label167: '存款金額',
    label168: '50天',
    label169: '80天',
    label170: '100天',
    label171: '160天',
    label172: '已存入',
    label173: '存款',
    label174: '暫無數據',
    label175: '賬戶',
    label176: '請選擇賬單月份',
    label177: '幣種',
    label178: '存款期限',
    label179: '請選擇存入幣種',
    label180: '請選擇存入期限',
    label181: '請選擇購買賬戶',
    label182: '金額不能為空',
    label183: '請輸入正確的金額',
    label184: '請同意條款',
    label185: '收益賬戶',
    label186: '支取至',
    label187: '請選擇簽約賬戶',
    label188: '預計收益',
    label189: '請選擇派息頻率',
    label190: '請輸入留存金額',
    label191: '支取金額',
    label192: '請輸入支取金額',
    label193: '可取出',
    label194: '全部支取',
    label195: '请输入供款金额',
    label196: '请选择供款账户',
    label197: '供款金額不能為空',
    label198: '供款賬號不能為空',
    label199: '供款金額不能小於{0}',
    label200: '您沒有該幣種賬戶',
    label201: '沒有更多數據了……',
    label202: '本金自動轉存',
    label203: '本息自動轉存',
    label204: '到期轉入轉出賬戶',
    label205: '年',
    label206: '個月',
    label207: '天',
    label208: '年',
    label209: '個月',
    label210: '天',
    label211: '您沒有該幣種賬戶，將自動為您切換賬戶',
    label212: '您名下沒有賬戶',
    label213: '，清楚並同意該',
    label214: '《協議條款》',
    label215: '恭喜您完成購買慧月高產品，若有綁定以下服務，您可前往我行任一分行領取價值MOP100面值的文具禮券，先到先得，送完即止。\n' +
      '服務包括：信用卡/信用卡自動還款/銀證通/保險/CEM自動繳費/稅費自動轉賬/現金分享自動入賬。',
    label216: '我的購買',
    label217: '本次活動利率表',

    label218: '存款週期：',
    label219: '提供幣種：',
    label220: '起存金額：',
    label221: '計息規則：按存期靠檔計息',
    label222: '利率：',
    label223: '期限',
    label224: '至',
    label225: '{0}天后',
    label226: '到期後安排',
    label227: '年利率：',
    label228: '最大購買金額為',
    label229: ''
  },
  title: {
    title0: '產品分類',
    title1: '智能存款產品',
    title2: '我的',
    title3: '存款信息詳情',
    title4: '交易記錄',
    title5: '月月高存款',
    title6: '信息錄入',
    title7: '交易結果',
    title8: '支取結果',
    title9: '信息確認',
    title10: '活期存款',
    title11: '定期存款',
    title12: '天天利存款',
    title13: '月供存款',
    title14: '{0}支取',
    title15: '{0}解約',
    title16: '',
    title17: '',
    title18: '',
    title19: ''
  },
  argument: {
    // 月月高
    argument1: '1.「3+2+1月月高」存款之利息將分為3個階段計算：',
    argument2: '2.「5+5+2月月高」存款之利息將分為3個階段計算：',
    argument3: '3.每階段期滿後提前支取，客戶可支取已滿階段的利息及本金；如在未滿階段前提前支取，將不獲發未滿階段存款利息。',
    argument4: '4.上述之計息資料僅供參考，一切賬項須以銀行入賬記錄為準。 ',
    argument5: '5.推廣期有限，額滿即止。',
    argument6: '6.立橋銀行股份有限公司保留所有條款及細則的權利，而無須另行通知。',
    argument7: '7.上述推廣受條款及細則約束，如有任何爭議，立橋銀行保留對上述推廣的最終審核、終止與解釋之權利。',
    argument8: '8.如本條款及細則的中、英文版本有歧異， 一律以中文版本為準。',
    argument50: '1）第1階段為開立定期存款日起計算3個月；第2階段為開立定期存款日起計第4至第5個月；第3階段為開立定期存款日第6個月至存款到期日。',
    argument51: '2)本金及利息將於6個月期滿的到期日入賬至客戶原扣賬賬戶中。',
    argument52: '1）第1階段為開立定期存款日起計算首5個月；第2階段為開立定期存款日起計第6個月至第10個月；第3階段為開立定期存款日起計第11個至第12個月。',
    argument53: '2) 本金及利息將於12個月期滿的到期日入賬至客戶原扣賬賬戶中。',
    argument54: '',
    argument55: '',
    argument56: '',
    argument57: '',
    argument58: '',
    // 天天利
    argument9: '1.「160天天金」存款之利息將分為3個階段計算，1)第1階段為開立存款日起計算100日；第2階段為開立存款日起計第101日至第150日；第3階段為開立存款日第151日至存款到期日。2)存款利息每50日派息一次。',
    argument10: '2.「100天天金」存款之利息將分為3個階段計算，1)第1階段為開立存款日起計算60日；第2階段為開立存款日起計第61日至第90日；第3階段為開立存款日第91日至存款到期日。2)存款利息每30日派息一次。',
    argument11: '3.「50天天金」存款之利息將分為3個階段計算，1)第1階段為開立存款日起計算30日；第2階段為開立存款日起計第31日至第45日；第3階段為開立存款日第46日至存款到期日。2)存款利息每15日派息一次。',
    argument12: '4.利息將按存款餘額計算於指定週期派息日完結後的下一日存入客戶的指定賬戶；提前取出本金部份之利息將按實際存款期(按天)計算，有關利息將於提取時同時存入客戶原扣賬賬戶。',
    argument13: '5.上述之計息資料僅供參考， 一切賬項須以銀行記錄為準。',
    argument14: '6.客戶起存金額為等值澳門幣100元，上限為等值澳門幣100萬元。',
    argument15: '7.推廣期有限，額滿即止。',
    argument16: '8.立橋銀行股份有限公司保留所有條款及細則的權利，而無須另行通知。',
    argument17: '9.上述推廣受條款及細則約束，如有任何爭議，立橋銀行保留對上述推廣的最終審核、終止與解釋之權利。',
    argument18: '10.如本條款及細則的中、英文版本有歧異， 一律以中文版本為準。',
    // 定期
    argument19: '1.本金及利息將於存款到期日自動存入原扣賬戶口。',
    argument20: '2.推廣期有限，額滿即止。',
    argument21: '3.立橋銀行股份有限公司保留所有條款及細則的權利，而無須另行通知。',
    argument22: '4.上述推廣受條款及細則約束，如有任何爭議，立橋銀行保留對上述推廣的最終審核、終止與解釋之權利。',
    argument23: '5.如本條款及細則的中、英文版本有歧異， 一律以中文版本為準。',
    // 活期
    argument24: '1.該產品是一種根據客戶約定，將就活期賬戶扣除約定留存金額後的資金存入智能存款賬戶，按日均餘額靠檔計息。',
    argument25: '2.每日日終，如客戶的活期賬戶餘額高於客戶約定留存金額，將就活期賬戶扣除約定留存金額後的資金存入智能存款賬戶；每日日終，如客戶的活期賬戶留存金額低於客戶約定留存金額，將就智能存款賬戶扣除相關金額，補足活期賬戶的留存金額。',
    argument26: '3.利息於每月存入客戶原扣款賬戶。',
    argument27: '4.如需解約該產品，需辦理終止手續。',
    argument28: '5.計息資料僅供參考，一切賬項須以銀行入賬記錄為準。 ',
    argument29: '6.推廣期有限，額滿即止。',
    argument30: '7.立橋銀行股份有限公司保留所有條款及細則的權利，而無須另行通知。',
    argument31: '8.上述推廣受條款及細則約束，如有任何爭議，立橋銀行保留對上述推廣的最終審核、終止與解釋之權利。',
    argument32: '9.如本條款及細則的中、英文版本有歧異， 一律以中文版本為準。',
    // 月供
    argument33: '1.月供存款必須透過本行賬戶安排自動轉賬；',
    argument34: '2.簽約月供存款產品，不能同時簽約高息活期產品；',
    argument35: '3.月供款項將於每月1號在客戶指定賬戶中扣取；',
    argument36: '4.倘若客戶逾期供款，將不影響賬戶正常計息，最終可獲利息按照實際存入金額計算；',
    argument37: '5.取消月供存款賬戶或提前支取月供存款賬戶內的款項將不獲發利息；',
    argument38: '6.年利率及匯率將根據市況變化而不時調整，立橋銀行股份有限公司保留隨時更改上述利率及匯率優惠之權利；',
    argument39: '7.客戶起存金額為存入相應幣種的500元，上限為存入相應幣種的100萬元。',
    argument40: '8.推廣期有限，額滿即止；',
    argument41: '9.立橋銀行股份有限公司保留所有條款及細則的權利，而無須另行通知；',
    argument42: '10.上述推廣受條款及細則約束，如有任何爭議，立橋銀行保留對上述推廣的最終審核、終止與解釋之權利；',
    argument43: '11.如本條款及細則的中、英文版本有歧異， 一律以中文版本為準。'
  }
}
